import { createStyles } from "@mantine/core";

interface DrawerProps {
  fullScreen: boolean;
}

export const useStyles = createStyles((_, { fullScreen }: DrawerProps) => ({
  drawer: {
    height: fullScreen ? "100%" : "auto",
    borderRadius: "12px 12px 0px 0px",
    overflowY: "scroll",
  },
}));
